"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.availableAssets = exports.availableTypes = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var availableTypes = {
  DealsFill: 'DealsFill',
  HomeFill: 'HomeFill',
  HomeLine: 'HomeLine',
  MoneyCircleEnabledFill: 'MoneyCircleEnabledFill',
  MoneyCircleEnabledLine: 'MoneyCircleEnabledLine',
  OrderBagFill: 'OrderBagFill',
  PersonProfileFill: 'PersonProfileFill',
  PersonProfileLine: 'PersonProfileLine',
  ReceiptFill: 'ReceiptFill',
  ReceiptLine: 'ReceiptLine',
  SearchFill: 'SearchFill',
  SearchLine: 'SearchLine',
  VehicleBikeLine: 'VehicleBikeLine'
};
exports.availableTypes = availableTypes;
var availableAssets = {
  '24DealsFill': '24-deals-fill.svg',
  '24HomeFill': '24-home-fill.svg',
  '24HomeLine': '24-home-line.svg',
  '24MoneyCircleEnabledFill': '24-money-circle-enabled-fill.svg',
  '24MoneyCircleEnabledLine': '24-money-circle-enabled-line.svg',
  '24OrderBagFill': '24-order-bag-fill.svg',
  '24PersonProfileFill': '24-person-profile-fill.svg',
  '24PersonProfileLine': '24-person-profile-line.svg',
  '24ReceiptFill': '24-receipt-fill.svg',
  '24ReceiptLine': '24-receipt-line.svg',
  '24SearchFill': '24-search-fill.svg',
  '24SearchLine': '24-search-line.svg',
  '24VehicleBikeLine': '24-vehicle-bike-line.svg'
};
exports.availableAssets = availableAssets;